import { logUsage } from 'owa-analytics';
import { ComposeScenario } from './logSmartReplyComposeDatapoint';
import { ComposeViewState } from 'owa-mail-compose-store';

export function logSubjectPickerDatapoint(scenario: ComposeScenario, viewState: ComposeViewState) {
    if (viewState.subjectPickerViewState && viewState.subjectPickerViewState.wasSubjectSelected) {
        let eventName: string = null;

        switch (scenario) {
            case ComposeScenario.Send:
                eventName = 'SubjectPicker_SelectedSubjectSent';
                break;
            case ComposeScenario.Discard:
                eventName = 'SubjectPicker_SelectedSubjectDiscarded';
                break;
        }

        logUsage(eventName);
    }
}
